
























import { Component, Mixins } from 'vue-property-decorator'
import DatePickerBase from '@/components/atoms/DatePickerBase.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import { TEACHER_SETTING_TEXT } from '@/constants'
import QueryMethods from '@/components/atoms/QueryMethods.vue'
import StudentIdsInfo from './StudentIdsInfo.vue'
import dayjs from 'dayjs'

@Component({
  components: {
    SelectBase,
    TitleBase,
    TitleTextBase,
    ColoredBox,
    DatePickerBase,
    ButtonBase,
  },
})
export default class StudentCourseDate extends Mixins(QueryMethods, StudentIdsInfo) {
  private breadcrumbs = [
    { text: TEACHER_SETTING_TEXT, href: '/teacher/setting/top' },
    { text: '生徒', href: '/teacher/setting/v3/student' },
    { text: '利用期間選択', active: true },
  ]

  private date = ''
  private month = 1

  private monthOptions = Array.from({ length: 12 }, (_, i) => ({
    text: i + 1,
    value: i + 1,
  }))

  private handleSubmit() {
    this.$store.commit('studentCreationInfo/setStudentInfo', {
      date: dayjs(this.date).format('YYYY/MM/DD'),
      month: this.month,
    })
    this.$router.push(
      `/teacher/setting/v3/student/create/confirm?id=${this.userIds.join(',')}&studentId=${
        this.getParamsObject()['studentId']
      }`
    )
  }

  private get colortype(): string {
    const permitted = this.date && this.month
    return permitted ? 'blue' : 'pointer-events-none'
  }

  private handleDefaultData() {
    const { nickname, studentCode, schoolSelected, gradeSelected, date, month, standardCourses, alignedCourses } =
      this.$store.state.studentCreationInfo.studentInfo
    const validInfoStudent = nickname && studentCode && schoolSelected && gradeSelected
    const validInfoStudents =
      this.isChooseStandardCourses(standardCourses) || this.isChooseAlignedCourses(alignedCourses)

    if (this.isMultiStudent ? !validInfoStudents : !validInfoStudent) {
      alert('情報をすべて入力してください。')
      this.$router.push(`/teacher/setting/v3/student/create/info?id=${this.userIds.join(',')}`)
    }
    if (date) {
      this.date = dayjs(date).format('YYYY-MM-DD')
    }
    if (month) {
      this.month = month
    }
  }

  private async mounted() {
    await this.setParamsFromQuery()
    this.handleDefaultData()
  }
}
